import './assets/main.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

app.use(ElementPlus)

import { useAuthStore } from '@/stores/auth'

const init = async () => {
  const authStore = useAuthStore(pinia)
  if (authStore.token) {
    try {
      await authStore.fetchProfile()
    } catch (error) {
      console.log('OH NO')
      authStore.logout()
    }
  }
  app.use(router)
  app.mount('#app')
}

init()
